










































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { FarmProps } from './types';

@Component({
  name: "FarmDrawConfirm",
})
export default class FarmDrawConfirm extends Vue {
  @Prop({ type: Boolean, default: false })
  private isVisible!: boolean;

  @Prop(Object)
  private farm!: FarmProps;

  private farmName: string = this.farm.farmName;

  private mounted() {
    this.farmName = this.farm.farmName;
  }

  @Emit('onsubmit')
  public confirmCreateFarm() {
    const name = this.farmName;
    this.farmName = '';
    return name;
  }

  @Emit('oncancel')
  public editFarm() {
    this.farmName = '';
  }
}
